import React, { useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Button } from 'antd';
import useApi from '../../hooks/useApi';

const EditarCredencial = ({ open, onClose, onSuccess }) => {
  const [form] = Form.useForm();

  const { callApi: getCredentials } = useApi('https://vision.alfama.com/api/view/credencial/1', {
    method: 'GET',
    includeToken: true,
  });

  const { callApi: updateCredentials, loading: isSubmitting } = useApi('https://vision.alfama.com/api/update/dashboards/credencial/1', {
    method: 'PUT',
    includeToken: true,
    successMessage: 'Credenciais atualizadas com sucesso!',
    errorMessage: 'Erro ao atualizar credenciais.'
  });

  useEffect(() => {
    const fetchCredentials = async () => {
      if (open) {
        const response = await getCredentials();
        if (response) {
          form.setFieldsValue({
            clientId: response.clientId || '',
            clientSecret: response.clientSecret || '',
            tenantId: response.tenantId || ''
          });
        } else {
          form.resetFields();
        }
      }
    };

    fetchCredentials();
  }, [open, form, getCredentials]);

  const handleSubmit = async (values) => {
    const response = await updateCredentials(values);
    if (response) {
      form.resetFields();
      if (onSuccess) onSuccess();
      onClose();
    }
  };

  return (
    <Modal
      title="Editar Credenciais"
      open={open}
      onCancel={onClose}
      width={500}
      confirmLoading={isSubmitting}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={isSubmitting}
          onClick={() => form.submit()}
        >
          Atualizar
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="clientId"
              label="Client ID"
              rules={[
                { required: true, message: 'Insira o Client ID' }
              ]}
            >
              <Input placeholder="Digite o Client ID" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="clientSecret"
              label="Client Secret"
              rules={[
                { required: true, message: 'Insira o Client Secret' }
              ]}
            >
              <Input.Password placeholder="Digite o Client Secret" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="tenantId"
              label="Tenant ID"
              rules={[
                { required: true, message: 'Insira o Tenant ID' }
              ]}
            >
              <Input placeholder="Digite o Tenant ID" />  
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditarCredencial;